import { Box } from "@mui/material";
import styled from "styled-components";

export const AdminStyled = styled(Box)`
  margin: 56px;
  @media (max-width: 576px) {
    margin: 26px 16px;
  }
`;
